import { useState } from 'react';

import {  Typography, message, Modal, Row, Col, Divider } from 'antd';

import { CheckCircleFilled, CloseCircleFilled, InfoCircleFilled, Card } from '@ant-design/icons';

import './coupon.scss';

import { useTranslation } from 'soxo-bootstrap-core';

import PriceFormatter from '../format-price/format-price';

const { Title, Text } = Typography;

export default function Coupon({ isSuccess, couponDetails, visible, currency, showInfoIcon }) {

    // State for Modal visibility
    const [isModalVisible, setIsModalVisible] = useState(false);

    const { t, i18n } = useTranslation(); // To Translate to another language


    const handleInfoClick = () => {
        setIsModalVisible(true); // Open the modal
    };
    const handleModalClose = () => {
        setIsModalVisible(false); // Close the modal
    };

    let corporatePayable = <PriceFormatter price={couponDetails?.corporate_payable}
        locale={currency.priceFormat}
        currency={currency.currency_code}
        enablePriceFormatting={currency.enablePriceFormatting}
    />

    let couponDiscount = <PriceFormatter price={couponDetails?.coupon_value}
        locale={currency.priceFormat}
        currency={currency.currency_code}
        enablePriceFormatting={currency.enablePriceFormatting}
    />

    let advancePaidByCorporate = <PriceFormatter price={couponDetails?.advance_paid_by_corporate}
        locale={currency.priceFormat}
        currency={currency.currency_code}
        enablePriceFormatting={currency.enablePriceFormatting}
    />

    return visible ? (

        <div
            className={`coupon-card card card-shadow ${isSuccess ? 'coupon-card-success' : 'coupon-card-error'
                }`}>

            {/* Title Section */}
            <div
                className={`coupon-title ${isSuccess ? 'coupon-title-success' : 'coupon-title-error'
                    }`}

            >
                {isSuccess ? (
                    <CheckCircleFilled className="coupon-icon" style={{ color: '#52c41a' }} />
                ) : (
                    <CloseCircleFilled className="coupon-icon" style={{ color: '#ff4d4f' }} />
                )}
                <Text
                    className={`coupon-title ${isSuccess
                        ? 'coupon-title-success'
                        : 'coupon-title-error'
                        }`}
                ><strong>{t('Coupon Applied')}</strong></Text>

                {showInfoIcon && (
                    <InfoCircleFilled className="coupon-info-icon"
                        onClick={handleInfoClick}
                    />
                )}
            </div>

            {/* Description Section */}
            <Text
                className={`coupon-description ${isSuccess
                    ? 'coupon-description-success'
                    : 'coupon-description-error'
                    }`}
            >
                <strong> {couponDetails?.coupon_no}</strong> {t('Nura Coupon has been applied')}
            </Text>
            {/* Modal for Coupon Details */}
            <Modal
                title="COUPON INFO"
                width={'50%'}
                visible={isModalVisible}
                onCancel={handleModalClose}
                footer={null}
            >
                <>
                    <div style={{ marginBottom: 16 }}>
                        <strong>{couponDetails?.coupon_description}</strong>
                    </div>
                    <div style={{ marginBottom: 16 }}>
                        <strong>{couponDetails?.coupon_no}</strong> {t('Nura Coupon has been applied')}
                    </div>

                    {/* Row and Col Layout */}
                    <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                        <Col span={8}>
                            <Text type='secondary'>{t('COUPON DISCOUNT')}</Text>
                            <br />
                            <span><strong>{couponDiscount}</strong></span>
                        </Col>
                        {/* <Divider type="vertical"  style={{ margin: '8px 0' }} /> */}
                        <Col span={8}>
                            <Text type='secondary'>{t('CORPORATE AMOUNT')}</Text>
                            <br />
                            <span><strong>{couponDetails?.corporate_payable_calculation_type && couponDetails?.corporate_payable_calculation_type == "P" && couponDetails?.corporate_payable_percentage ? "("+couponDetails?.corporate_payable_percentage+"%)" : ""}{corporatePayable}</strong></span>
                        </Col>
                        {/* <Divider type="vertical"   style={{ margin: '8px 0' }}/> */}
                        <Col span={8}>
                            <Text type='secondary'>{t('ADVANCE AMOUNT')}</Text>
                            <br />
                            <span><strong>{advancePaidByCorporate}</strong></span>
                        </Col>
                    </Row>

                    <Row gutter={[16, 16]} style={{ marginBottom: 16 }}>
                        <Col span={8}>
                            <Text type='secondary'>{t('CORPORATE')}</Text>
                            <br />
                            <span><strong>{couponDetails?.corporate_description}</strong></span>
                        </Col>
                        {/* <Divider type="vertical" /> */}
                        <Col span={8}>
                            <Text type='secondary'>{t('REFERRAL')}</Text>
                            <br />
                            <span><strong>{couponDetails?.referrer_description}</strong></span>
                        </Col>
                    </Row>

                </>
            </Modal>
        </div>

    ) : null;
};

